import moment from 'moment';

// Turn readable parts into a safe file-name chunk: "Tariq Mehmood" -> "Tariq-Mehmood".
const clean = (part) =>
  String(part)
    .trim()
    .replace(/[\\/:*?"<>|]+/g, '')
    .replace(/\s+/g, '-');

// Format a date (string/Date/moment) as DD-MM-YYYY; empty when missing/invalid.
export const pdfDate = (value) => {
  if (!value) return '';
  const m = moment(value);
  return m.isValid() ? m.format('DD-MM-YYYY') : '';
};

// Date label for a From–To range, e.g. "01-10-2026-to-07-10-2026" (or a single date).
export const pdfDateRange = (start, end) => {
  const s = pdfDate(start);
  const e = pdfDate(end);
  if (s && e && s !== e) return `${s} to ${e}`;
  return s || e;
};

// Build "Part1_Part2_<date>.pdf". Empty parts are skipped; the date defaults to today.
export const pdfFileName = (parts, date) => {
  const list = (Array.isArray(parts) ? parts : [parts])
    .filter((p) => p !== null && p !== undefined && String(p).trim() !== '')
    .map(clean);
  list.push(clean(date || moment().format('DD-MM-YYYY')));
  return `${list.join('_')}.pdf`;
};

// Open the PDF in a new tab only, with the file name as the tab title.
export const openPdf = (pdfMake, docDefinition, fileName) => {
  docDefinition.info = { ...(docDefinition.info || {}), title: fileName.replace(/\.pdf$/i, '') };
  pdfMake.createPdf(docDefinition).open();
};
